import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Attach auth token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bj_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authApi = {
  login: (email, password) => api.post("/auth/login", { email, password }),
  me: () => api.get("/auth/me"),
  logout: () => api.post("/auth/logout"),
};

export const publicApi = {
  getSettings: () => api.get("/settings"),
  submitQuote: (data) => api.post("/quotes", data),
};

export const adminApi = {
  listQuotes: () => api.get("/admin/quotes"),
  updateQuoteStatus: (id, status) =>
    api.patch(`/admin/quotes/${id}`, null, { params: { status } }),
  deleteQuote: (id) => api.delete(`/admin/quotes/${id}`),
  updateSettings: (data) => api.put("/admin/settings", data),
};
